// extracted by mini-css-extract-plugin
module.exports = {"search":"D_ct","input":"D_cv","search-icon":"D_cw","searchIcon":"D_cw"};